<template> 
    <div id="app">
        <mainmenu-component/>
        <!--<router-link to="/test">Go to Bar</router-link>-->
        <div id="main-section" style="background-color: ">
            <router-view ></router-view>
        </div> 
        <footer-component  />
		   <cookie-law theme="blood-orange" 
    buttonText="Akceptuję" 
    position="top" 
    transitionName="fade" 
	buttonLinkText="Regulamin strony"
	buttonLink="/static/regulamin.pdf"
	 message="Strona korzysta z plikow cookie"
    > </cookie-law>
    </div>
</template>

<script>
    import FirebaseAPI from './dao/FirebaseAPI.js'
        import MainMenu from './components/MainMenu.vue'
        import CookieLaw from 'vue-cookie-law';

        import CalendarView from './components/CalendarView.vue'
        import Footer from './components/Footer.vue'

        FirebaseAPI.auth();
    export default {
        name: 'app',
        components: {
            'mainmenu-component': MainMenu, 
            'footer-component': Footer,
			'cookie-law':  CookieLaw 
        },
        data() {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<style>
.Cookie{background-color: #FF9400 !important;color:black !important}
.Cookie__button{background-color: #98CDF9 !important;color:black !important}
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }


</style>



// WEBPACK FOOTER //
// src/App.vue